export default __webpack_public_path__ + "static/media/imagePlaceholder.31949a00.png";